import React, { useContext, useState } from 'react';
import { MultipleRulesContext } from '../multiple_rules/context';
import { EditDivider } from '../shared/divider';
import { DataRetentionRulesContext } from './context';
import type { DataRetentionRuleInterface } from './data_retention_rule';
import DeletionConfiguration from './edit/deletion_configuration';
import DeletionNotification from './edit/deletion_notification';
import RetentionDays from './edit/retention_days';
import RetentionFooter from './edit/retention_footer';
import RetentionOffices from './edit/retention_offices';

type Props = {
  rule: DataRetentionRuleInterface;
};

export default function EditRule(props: Props) {
  const { offices } = useContext(MultipleRulesContext);
  const { edited, errors, meta, onFieldChange, onCancel, onDelete, onSave } =
    useContext(DataRetentionRulesContext);
  const [rule, setRule] = useState<DataRetentionRuleInterface>(props.rule);

  const errorsPresent = Object.keys(errors).some(
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
    (key) => errors[key] && errors[key].length
  );

  return (
    <div data-provides="retention_rule_form">
      <RetentionDays
        days={rule.data_retention_days}
        // @ts-expect-error - TS2339 - Property 'data_retention_days' does not exist on type '{}'.
        errors={errors.data_retention_days}
        ruleId={rule.id}
        // @ts-expect-error - TS7006 - Parameter 'days' implicitly has an 'any' type.
        onChange={(days) => {
          onFieldChange('data_retention_days');
          setRule({ ...rule, data_retention_days: days });
        }}
      />
      <RetentionOffices
        allOfficesPath={meta.all_offices_path}
        // @ts-expect-error - TS2339 - Property 'data_retention_rule_offices' does not exist on type '{}'.
        errors={errors.data_retention_rule_offices}
        rule={rule}
        offices={offices}
        // @ts-expect-error - TS7006 - Parameter 'officeIds' implicitly has an 'any' type.
        onChange={(officeIds) => {
          onFieldChange('data_retention_rule_offices');
          setRule({ ...rule, office_ids: officeIds });
        }}
        // @ts-expect-error - TS7006 - Parameter 'allOffices' implicitly has an 'any' type.
        onToggleAllOffices={(allOffices) => {
          onFieldChange('data_retention_rule_offices');
          setRule({ ...rule, all_offices: allOffices });
        }}
      />
      <EditDivider />
      <DeletionConfiguration
        dataToDelete={rule.data_to_be_deleted}
        // @ts-expect-error - TS7006 - Parameter 'dataToDelete' implicitly has an 'any' type.
        onChangeDataToDelete={(dataToDelete) => {
          onFieldChange('data_to_be_deleted');
          setRule({ ...rule, data_to_be_deleted: dataToDelete });
        }}
      />
      <EditDivider />
      <DeletionNotification
        daysOfWeek={rule.days_of_week}
        emails={rule.emails}
        // @ts-expect-error - TS7006 - Parameter 'daysOfWeek' implicitly has an 'any' type.
        onChangeDaysOfWeek={(daysOfWeek) => {
          onFieldChange('days_of_week');
          setRule({ ...rule, days_of_week: daysOfWeek });
        }}
        // @ts-expect-error - TS7006 - Parameter 'emails' implicitly has an 'any' type.
        onChangeEmails={(emails) => {
          onFieldChange('notification_recipients');
          setRule({ ...rule, emails });
        }}
        // @ts-expect-error - TS7006 - Parameter 'selectedUsers' implicitly has an 'any' type.
        onChangeSelectedUsers={(selectedUsers) => {
          onFieldChange('notification_recipients');
          setRule({ ...rule, selected_users: selectedUsers });
        }}
        // @ts-expect-error - TS7006 - Parameter 'time' implicitly has an 'any' type.
        onChangeTime={(time) => {
          onFieldChange('time');
          setRule({ ...rule, time: time === null ? null : time.value });
        }}
        // @ts-expect-error - TS7006 - Parameter 'timeZone' implicitly has an 'any' type.
        onChangeTimezone={(timeZone) => {
          onFieldChange('time_zone');
          setRule({
            ...rule,
            time_zone: timeZone === null ? null : timeZone.value,
          });
        }}
        selectedUsers={rule.selected_users}
        time={rule.time}
        timezone={rule.time_zone}
      />
      <EditDivider />
      <RetentionFooter
        errorsPresent={errorsPresent}
        hideDelete={!rule.id}
        onCancel={() => {
          setRule(rule);
          onCancel();
        }}
        onDelete={() => onDelete(rule)}
        onSave={() => onSave(rule)}
        skipCancelPrompt={!edited}
      />
    </div>
  );
}
